import { render, staticRenderFns } from "./ProductAttributeField.vue?vue&type=template&id=0d042e43&scoped=true&"
import script from "./ProductAttributeField.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d042e43",
  null
  
)

export default component.exports